
import Vue from 'vue';
import Component from 'vue-class-component';
import TermsOfUse from '@/login/components/TermsOfUse/TermsOfUse.vue';

@Component({
	components: {
		TermsOfUse,
	},
})
export default class Terms extends Vue {}
